import {gradesLabels} from './i18n-labels';
import {grades} from './constants-enumerate';

const gradesList = [
  {
    label: gradesLabels[grades.NOT_SET],
    value: grades.NOT_SET,
  },
  {
    label: gradesLabels[grades.PREKINDERGARTEN],
    value: grades.PREKINDERGARTEN,
  },
  {
    label: gradesLabels[grades.KINDERGARTEN],
    value: grades.KINDERGARTEN,
  },
  {
    label: gradesLabels[grades.GRADE_1],
    value: grades.GRADE_1,
  },
  {
    label: gradesLabels[grades.GRADE_2],
    value: grades.GRADE_2,
  },
  {
    label: gradesLabels[grades.GRADE_3],
    value: grades.GRADE_3,
  },
  {
    label: gradesLabels[grades.GRADE_4],
    value: grades.GRADE_4,
  },
  {
    label: gradesLabels[grades.GRADE_5],
    value: grades.GRADE_5,
  },
  {
    label: gradesLabels[grades.OTHER],
    value: grades.OTHER,
  },
];


export {
  gradesList,
};
